import { createSelector } from '@ngrx/store';
import { selectAppState } from '../../reducers/reducer.selector';


export const selectUserState = createSelector(
  selectAppState,
  (state) => state.user
)

export const selectUserId = createSelector(
  selectUserState,
  (state) => state?.userId
)

export const selectActivePipeline = createSelector(
  selectUserState,
  (state) => state?.openRenderPipelineId
)

export const selectGroupId = createSelector(
  selectUserState,
  (state) => state?.groupId
)

